import { GridColDef } from "@mui/x-data-grid";
import { t } from "i18next";
import DataGridApi from "../../../../components/dataGridApi";
import { ISpreadsheet } from "../../../../interfaces/ISpreadsheet";
import { CONFIG } from "../../../../services/config";

interface Props {
  spreadsheet?: ISpreadsheet;
}

export default function Revalidacao({ spreadsheet }: Props) {
  const columns: GridColDef[] = [
    {
      field: "vin",
      flex: 2,
      headerName: t("digitalServicePlan.warrantyVin"),
      headerClassName: "header-style",
    },
    {
      field: "revisionDate",
      flex: 1,
      headerName: t("digitalServicePlan.revisionDate"),
      headerClassName: "header-style",
    },
    {
      field: "serviceLost",
      flex: 1,
      headerName: t("digitalServicePlan.serviceLost"),
      headerClassName: "header-style",
    },
    {
      field: "odometer",
      flex: 1,
      headerName: t("digitalServicePlan.odometer"),
      headerClassName: "header-style",
    },
  ];
  return (
    <DataGridApi
      params1="&param="
      labelParams1="Chassi"
      host={CONFIG.SOB_API}
      endPoint={`excel/revalidate/${spreadsheet?.id}?`}
      columnsData={columns}
    />
  );
}
